import ConnectionIndicator from 'modules/overlay-v2/ui/components/full-size-control-panel/connection-indicator';
import Period from 'modules/overlay-v2/ui/components/full-size-control-panel/period';
import SyncStateButton from 'modules/overlay-v2/ui/components/full-size-control-panel/sync-state-button';
import TeamPanel from 'modules/overlay-v2/ui/components/full-size-control-panel/team-panel';
import TvBoardControl from 'modules/overlay-v2/ui/components/full-size-control-panel/tv-board-control';
import PreparationScreen from 'modules/overlay-v2/ui/components/preparation-screen';
import useInitControlPanelV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-control-panel-v2';
import { PopupRegistryProvider } from 'modules/overlay-v2/ui/hooks/popup-registry';
import useOverlayReadiness from 'modules/overlay-v2/ui/hooks/use-overlay-readiness';

import { FullSizeControlPanelWrapper } from './styles';

/**
 * Панель управления табло. В отличие от старой версии не знает номера матча: и она, и оверлей
 * открываются по ссылке устройства, а матч приходит из трансляции и может смениться на лету.
 *
 * Табло на оверлее переключаются из мобильного приложения, поэтому здесь их списка нет:
 * панель ведёт счёт, фолы и тайм, а из окон открывает только экран в зале (TV).
 */
function FullSizeControlPanel() {
  useInitControlPanelV2();

  const readiness = useOverlayReadiness();

  return (
    <>
      {/* По `isOnAir`, а не по `isReady`: см. комментарий в `overlayV2.tsx`. */}
      {readiness.isOnAir && (
        <PopupRegistryProvider>
          <FullSizeControlPanelWrapper>
            <div className={'flex flex-row flex-wrap gap-4'}>
              <ConnectionIndicator />
              <SyncStateButton />
            </div>
            <div className={'mt-4 flex flex-row gap-4'}>
              <Period className={'flex flex-wrap'} style={{ maxWidth: 270 }} />
              <TvBoardControl />
            </div>
            <div className="mt-4 flex flex-wrap gap-8">
              <TeamPanel className="grow" teamIndex={0} />
              <TeamPanel className="grow" teamIndex={1} />
            </div>
          </FullSizeControlPanelWrapper>
        </PopupRegistryProvider>
      )}

      {/* Чеклист или знак ImGame — по тем же правилам, что на оверлее. */}
      <PreparationScreen readiness={readiness} />
    </>
  );
}

export default FullSizeControlPanel;
